import { useEffect, useMemo, useState } from "react";
import { COUNTRY_OPTIONS, defaultRegion, formatPhone, rememberRegion } from "../lib/phone";
import { useProfile } from "../hooks/useProfile";

export const CountrySelect = ({ value, onChange, testid = "country-select" }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const cur = COUNTRY_OPTIONS.find((c) => c.cc === value) || COUNTRY_OPTIONS[0];
  const list = q ? COUNTRY_OPTIONS.filter((c) => `${c.name} ${c.cc} ${c.dial}`.toLowerCase().includes(q.toLowerCase())) : COUNTRY_OPTIONS;
  return (
    <div className="relative">
      <button type="button" className="country-btn" onClick={() => setOpen(!open)} data-testid={testid} data-country={cur.cc} aria-label="Country">{cur.flag} <span className="text-xs">{cur.dial}</span></button>
      {open && (
        <div className="country-pop" data-testid={`${testid}-list`}>
          <input className="field field-sm" placeholder="Search country" value={q} onChange={(e) => setQ(e.target.value)} autoFocus data-testid={`${testid}-search`} />
          <div className="country-list">
            {list.slice(0, 60).map((c) => <button type="button" key={c.cc} className="country-item" onClick={() => { onChange(c.cc); setOpen(false); setQ(""); }} data-testid={`${testid}-option-${c.cc}`}>{c.flag} {c.name} <span className="text-muted">{c.dial}</span></button>)}
          </div>
        </div>
      )}
    </div>
  );
};

export const PhoneInput = ({ value, onChange, placeholder = "021 555 0123", testid = "phone", touched = true, autoComplete = "tel" }) => {
  const { profile } = useProfile() || {};
  const initial = useMemo(() => defaultRegion(profile?.phone), [profile?.phone]);
  const [region, setRegion] = useState(initial);
  useEffect(() => { if (!localStorage.getItem("dropit-phone-country")) setRegion(initial); }, [initial]);
  const f = value ? formatPhone(value, region) : { display: "", e164: "", valid: true };
  const set = (raw, r = region) => { const n = formatPhone(raw, r); onChange({ raw: n.display, e164: n.e164, valid: n.valid, region: r }); };
  const changeRegion = (r) => { setRegion(r); rememberRegion(r); set(value, r); };
  return (
    <div>
      <div className="flex gap-2">
        <CountrySelect value={region} onChange={changeRegion} testid={`${testid}-country`} />
        <input className="field flex-1" type="tel" inputMode="tel" autoComplete={autoComplete} value={value || ""} placeholder={placeholder} onChange={(e) => set(e.target.value)}
          onPaste={(e) => { e.preventDefault(); set(e.clipboardData.getData("text")); }} data-testid={`${testid}-input`} />
      </div>
      {f.e164 && <p className="text-xs text-[#2ECC71] mt-1" data-testid={`${testid}-e164`}>{f.e164}</p>}
      {touched && value && !f.valid && <p className="text-xs text-[#FF7A7A] mt-1" data-testid={`${testid}-error`}>That number doesn't look valid for {region}.</p>}
    </div>
  );
};
